import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m4 .636 11 10.998L26 .67a2.23 2.23 0 0 1 1.667-.666A2.5 2.5 0 0 1 30 2.336a2.2 2.2 0 0 1-.667 1.6L18.3 15l11.033 11.065c.434.42.674 1 .667 1.6a2.5 2.5 0 0 1-2.333 2.333A2.23 2.23 0 0 1 26 29.332L15 18.367 4.034 29.332A2.24 2.24 0 0 1 2.367 30a2.5 2.5 0 0 1-2.366-2.367 2.2 2.2 0 0 1 .666-1.6L11.7 15.002.634 3.935a2.2 2.2 0 0 1-.633-1.6A2.5 2.5 0 0 1 2.334.004a2.23 2.23 0 0 1 1.667.633z"
    }, null, -1)
  ])))
}
export default { render: render }